import { render, staticRenderFns } from "./InputDadosDocumentacao.vue?vue&type=template&id=4c1dc500&scoped=true"
import script from "./InputDadosDocumentacao.vue?vue&type=script&lang=js"
export * from "./InputDadosDocumentacao.vue?vue&type=script&lang=js"
import style0 from "./InputDadosDocumentacao.vue?vue&type=style&index=0&id=4c1dc500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1dc500",
  null
  
)

/* custom blocks */
import block0 from "./InputDadosDocumentacao.vue?vue&type=custom&index=0&blockType=FormularioDocumentacao&v-model%3Aestrangeiro=dadosDocumentacao.estrangeiro"
if (typeof block0 === 'function') block0(component)

export default component.exports